import styles from "./LoadingIndicator.module.scss";

import React from "react";
import classNames from "classnames";
import { Spinner } from "react-bootstrap";

interface IProps {
    readonly isActive?: boolean;
    readonly className?: string;
}
interface IState {}

export default class LoadingIndicator extends React.PureComponent<IProps, IState> {
    public static defaultProps: IProps = {
        isActive: false,
        className: undefined,
    };

    public render(): JSX.Element {
        const { children, isActive, className } = this.props;
        const cssClasses: string = classNames(className, {
            [styles.wrapper]: isActive,
        });

        return (
            <div className={cssClasses}>
                {isActive && (
                    <div className={styles.loaderContainer}>
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                )}
                {children}
            </div>
        );
    }
}
